import { render, staticRenderFns } from "./baoyou.vue?vue&type=template&id=2c01baa3&scoped=true"
var script = {}
import style0 from "./baoyou.vue?vue&type=style&index=0&id=2c01baa3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c01baa3",
  null
  
)

export default component.exports